"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _xDataGrid = require("@mui/x-data-grid");
var _filterSortUtils = require("./filterSortUtils");
var _CustomGridFilter = require("./filters/CustomGridFilter");
var _hierarchicalSelection = _interopRequireWildcard(require("./hierarchicalSelection"));
var _selectionUtils = require("./selectionUtils");
var _excluded = ["allRows", "onSelectionChange", "initialSelectedRowIds", "initialExplicitlyDeselectedIds", "columns", "rows", "checkboxSelection", "keepNonExistentRowsSelected", "forwardedRef"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var StyledDataGrid = (0, _styles.styled)(_xDataGrid.DataGrid)(function () {
  return {
    "--unstable_DataGrid-radius": "0px",
    "& .MuiCheckbox-root": {
      color: "#D0D0CE"
    },
    // Grid structure
    "& .MuiDataGrid-root": {
      borderRadius: "0px"
    },
    "& .MuiDataGrid": {
      borderRadius: "0px"
    },
    "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-cell": {
      borderRadius: "0 !important"
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none"
    },
    // Rows styling
    "& .MuiDataGrid-row": {
      borderRadius: "0 !important"
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "white"
      }
    },
    // Footer and scrolling
    "& .MuiDataGrid-footerContainer": {
      borderRadius: "0 !important",
      backgroundColor: "white"
    },
    "& .MuiDataGrid-virtualScroller": {
      borderRadius: "0 !important",
      overflowY: "auto !important"
    }
  };
});

// Helper functions moved outside component to reduce nesting
var createInteractiveHeaderRenderer = function createInteractiveHeaderRenderer(column, data, currentFilterState, columnId, createFilterCallback) {
  return function () {
    var _column$sortable, _column$filterable;
    return /*#__PURE__*/_react["default"].createElement(_CustomGridFilter.CustomGridFilter, {
      columnName: column.headerName || column.field,
      sortable: (_column$sortable = column.sortable) !== null && _column$sortable !== void 0 ? _column$sortable : false,
      filterable: (_column$filterable = column.filterable) !== null && _column$filterable !== void 0 ? _column$filterable : false,
      data: data,
      initialSort: (currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.sort) || "",
      initialFilters: (currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.filters) || [],
      callbackApplyFilters: createFilterCallback(columnId)
    });
  };
};
var createSimpleHeaderRenderer = function createSimpleHeaderRenderer(column) {
  return function () {
    return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      fontWeight: "bold"
    }, column.headerName || column.field);
  };
};
// Internal component without forwardRef
var CustomGridInternal = function CustomGridInternal(_ref) {
  var allRows = _ref.allRows,
    onSelectionChange = _ref.onSelectionChange,
    initialSelectedRowIds = _ref.initialSelectedRowIds,
    initialExplicitlyDeselectedIds = _ref.initialExplicitlyDeselectedIds,
    columns = _ref.columns,
    rows = _ref.rows,
    _ref$checkboxSelectio = _ref.checkboxSelection,
    checkboxSelection = _ref$checkboxSelectio === void 0 ? false : _ref$checkboxSelectio,
    _ref$keepNonExistentR = _ref.keepNonExistentRowsSelected,
    keepNonExistentRowsSelected = _ref$keepNonExistentR === void 0 ? false : _ref$keepNonExistentR,
    forwardedRef = _ref.forwardedRef,
    restProps = _objectWithoutProperties(_ref, _excluded);
  // Maintain selection state independently of rows
  var _React$useState = _react["default"].useState(new Set(initialSelectedRowIds || [])),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedRowIds = _React$useState2[0],
    setSelectedRowIds = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(new Set(initialExplicitlyDeselectedIds || [])),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    explicitlyDeselectedIds = _React$useState4[0],
    setExplicitlyDeselectedIds = _React$useState4[1];

  // State for sorting and filtering
  var _React$useState5 = _react["default"].useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    sortFilters = _React$useState6[0],
    setSortFilters = _React$useState6[1];

  // Track if we're updating from external props to avoid notification loops
  var isUpdatingFromPropsRef = _react["default"].useRef(false);

  // Sync external initialSelectedRowIds with internal state
  _react["default"].useEffect(function () {
    if (initialSelectedRowIds && !isUpdatingFromPropsRef.current) {
      // Check if the external selection is actually different from our internal state
      var currentInternalIds = new Set(Array.from(selectedRowIds));
      var newExternalIds = new Set(initialSelectedRowIds);

      // Compare sets - only update if they're actually different
      var hasChanged = currentInternalIds.size !== newExternalIds.size || !_toConsumableArray(currentInternalIds).every(function (id) {
        return newExternalIds.has(id);
      });
      if (hasChanged) {
        isUpdatingFromPropsRef.current = true;

        // Cancel any pending hierarchical updates when selection changes externally
        (0, _hierarchicalSelection.cancelPendingUpdates)();

        // Filter to keep only valid IDs that exist in current allRows
        var validIds = initialSelectedRowIds.filter(function (id) {
          return (allRows === null || allRows === void 0 ? void 0 : allRows.some(function (row) {
            return row.id === id;
          })) || false;
        });
        setSelectedRowIds(new Set(validIds));
        // Reset the flag after state update is complete
        globalThis.setTimeout(function () {
          isUpdatingFromPropsRef.current = false;
        }, 0);
      }
    }
  }, [initialSelectedRowIds, allRows, selectedRowIds]);

  // Sync external initialExplicitlyDeselectedIds with internal state
  _react["default"].useEffect(function () {
    if (initialExplicitlyDeselectedIds !== undefined) {
      setExplicitlyDeselectedIds(new Set(initialExplicitlyDeselectedIds));
    }
  }, [initialExplicitlyDeselectedIds, rows]);

  // Cancel pending hierarchical updates when rows change (navigation)
  _react["default"].useEffect(function () {
    (0, _hierarchicalSelection.cancelPendingUpdates)();
  }, [rows]);

  // Cleanup pending updates on unmount
  _react["default"].useEffect(function () {
    return function () {
      (0, _hierarchicalSelection.cancelPendingUpdates)();
    };
  }, []);

  // Helper functions using utilities
  var isRowSelected = _react["default"].useCallback(function (rowId) {
    return (0, _selectionUtils.isRowEffectivelySelected)(rowId, selectedRowIds, explicitlyDeselectedIds, allRows || []);
  }, [selectedRowIds, explicitlyDeselectedIds, allRows]);
  var getChildrenState = _react["default"].useCallback(function (parentId) {
    return (0, _selectionUtils.getChildrenSelectionState)(parentId, allRows || [], selectedRowIds, explicitlyDeselectedIds);
  }, [allRows, selectedRowIds, explicitlyDeselectedIds]);

  // Create handler for filter and sort updates using utility function
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var handleApplyFilters = _react["default"].useCallback((0, _filterSortUtils.createFilterSortHandler)(setSortFilters), [setSortFilters]);

  // Create external handlers for programmatic filter/sort management
  var externalHandlers = _react["default"].useMemo(function () {
    return (0, _filterSortUtils.createExternalFilterSortHandlers)(setSortFilters);
  }, [setSortFilters]);

  // Calculate header checkbox state based on all visible rows
  var getHeaderState = _react["default"].useCallback(function () {
    return (0, _selectionUtils.getHeaderCheckboxState)(rows || [], selectedRowIds, explicitlyDeselectedIds, allRows || []);
  }, [rows, selectedRowIds, explicitlyDeselectedIds, allRows]);

  //Add selected field to rows data based on selection state and apply filters/sorting
  var processedRows = _react["default"].useMemo(function () {
    if (!rows) return [];

    // Convert readonly array to mutable array and apply filters/sorting
    var mutableRows = Array.from(rows);
    var filteredAndSortedRows = (0, _filterSortUtils.applyFiltersAndSorting)(mutableRows, sortFilters, columns || []);

    // Then add selection state
    return filteredAndSortedRows.map(function (row) {
      return _objectSpread(_objectSpread({}, row), {}, {
        selected: isRowSelected(row.id)
      });
    });
  }, [rows, isRowSelected, sortFilters, columns]);
  // Track selection updates to detect stale setTimeout callbacks
  var selectionUpdateCountRef = _react["default"].useRef(0);

  // Function to update row selection with hierarchical logic
  var updateRowSelection = _react["default"].useCallback(function (rowId, selected) {
    if (!allRows) return;

    // Increment counter for this operation
    var operationId = ++selectionUpdateCountRef.current;
    var callCount = 0;
    var handleSelectionUpdate = function handleSelectionUpdate(newSelectedIds, newDeselectedIds) {
      callCount++;

      // CRITICAL FIX: Prevent clearing selection when we're selecting something
      // The hierarchicalSelection calls handleSelectionUpdate twice:
      // 1st call (immediate): valid update with correct IDs
      // 2nd call (setTimeout): can be stale with empty set due to closure
      // Only block if:
      // 1. This is the 2nd+ call (callCount > 1)
      // 2. We're selecting (selected=true)
      // 3. The update gives us an empty set
      // 4. This operation is still current (not superseded)
      var isStaleSecondCall = callCount > 1 && selected && newSelectedIds.size === 0 && operationId === selectionUpdateCountRef.current;
      if (isStaleSecondCall) {
        return;
      } // Set flag to prevent external sync from interfering
      isUpdatingFromPropsRef.current = true;
      setSelectedRowIds(newSelectedIds);
      setExplicitlyDeselectedIds(newDeselectedIds);

      // Reset the flag after a much longer delay to ensure all external effects complete
      globalThis.setTimeout(function () {
        isUpdatingFromPropsRef.current = false;
      }, 500);
    };
    (0, _hierarchicalSelection["default"])(rowId, selected, allRows, selectedRowIds, explicitlyDeselectedIds, handleSelectionUpdate);
  }, [allRows, selectedRowIds, explicitlyDeselectedIds]);

  // Function to handle select all functionality
  var handleSelectAll = _react["default"].useCallback(function (selected) {
    if (!rows || !allRows) return;
    var rowsArray = rows;

    // Get all root level rows (those without parents in the visible rows)
    var rootRows = rowsArray.filter(function (row) {
      var parentId = (0, _selectionUtils.getParentId)(row);
      return !rowsArray.some(function (parentRow) {
        return parentRow.id === parentId;
      });
    });

    // Cancel any pending hierarchical updates
    (0, _hierarchicalSelection.cancelPendingUpdates)();

    // Set flag to prevent external sync from interfering
    isUpdatingFromPropsRef.current = true;

    // Create new sets for selection state
    var newSelectedIds = new Set(selectedRowIds);
    var newDeselectedIds = new Set(explicitlyDeselectedIds);
    if (selected) {
      // Select all root rows and their descendants
      var _iterator = _createForOfIteratorHelper(rootRows),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          newSelectedIds.add(row.id);
          newDeselectedIds["delete"](row.id);

          // Also select all descendants using the utility function
          var descendants = (0, _selectionUtils.getAllDescendants)(row.id, allRows);
          var _iterator2 = _createForOfIteratorHelper(descendants),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var id = _step2.value;
              newSelectedIds.add(id);
              newDeselectedIds["delete"](id);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      // Deselect all root rows and their descendants
      var _iterator3 = _createForOfIteratorHelper(rootRows),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _row = _step3.value;
          newSelectedIds["delete"](_row.id);

          // Also deselect all descendants using the utility function
          var _descendants = (0, _selectionUtils.getAllDescendants)(_row.id, allRows);
          var _iterator4 = _createForOfIteratorHelper(_descendants),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _id = _step4.value;
              newSelectedIds["delete"](_id);
              newDeselectedIds["delete"](_id);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    // Update the state
    setSelectedRowIds(newSelectedIds);
    setExplicitlyDeselectedIds(newDeselectedIds);

    // After updating selection, update parent states based on hierarchical logic
    // This ensures that when all children are selected, parents are automatically selected too
    var _updateParentSelectio = (0, _hierarchicalSelection.updateParentSelectionStates)(allRows, newSelectedIds, newDeselectedIds),
      newSelectedSet = _updateParentSelectio.newSelectedSet,
      newDeselectedSet = _updateParentSelectio.newDeselectedSet;

    // Update with the hierarchically corrected states
    if (newSelectedSet.size !== newSelectedIds.size || newDeselectedSet.size !== newDeselectedIds.size) {
      setSelectedRowIds(newSelectedSet);
      setExplicitlyDeselectedIds(newDeselectedSet);
    }

    // Reset the flag after state update
    globalThis.setTimeout(function () {
      isUpdatingFromPropsRef.current = false;
    }, 500);
  }, [rows, allRows, selectedRowIds, explicitlyDeselectedIds]);

  // Get selected rows - include both visible and non-visible selected rows when keepNonExistentRowsSelected is true
  var selectedRows = _react["default"].useMemo(function () {
    var visibleSelectedRows = processedRows.filter(function (row) {
      var isSelected = isRowSelected(row.id);
      return isSelected;
    });
    if (keepNonExistentRowsSelected && allRows) {
      // Also include selected rows that are not in current view but exist in allRows
      var visibleRowIds = new Set(processedRows.map(function (row) {
        return row.id;
      }));
      var nonVisibleSelectedRows = allRows.filter(function (row) {
        var isSelected = isRowSelected(row.id);
        var isVisible = visibleRowIds.has(row.id);
        return isSelected && !isVisible;
      });
      var totalSelected = [].concat(_toConsumableArray(visibleSelectedRows), _toConsumableArray(nonVisibleSelectedRows));
      return totalSelected;
    }
    return visibleSelectedRows;
  }, [processedRows, isRowSelected, keepNonExistentRowsSelected, allRows, selectedRowIds, explicitlyDeselectedIds]);

  // Notify parent component when selection changes - use ref to prevent unnecessary calls
  var previousSelectedRowsRef = _react["default"].useRef([]);
  _react["default"].useEffect(function () {
    if (onSelectionChange) {
      // Only call onSelectionChange if selection has actually changed - use Set comparison for IDs
      var currentIds = new Set(selectedRows.map(function (row) {
        return row.id;
      }));
      var previousIds = new Set(previousSelectedRowsRef.current.map(function (row) {
        return row.id;
      }));

      // Check if sets are equal (same size and all elements match)
      var hasChanged = currentIds.size !== previousIds.size || !_toConsumableArray(currentIds).every(function (id) {
        return previousIds.has(id);
      });
      if (hasChanged) {
        previousSelectedRowsRef.current = selectedRows;

        // Always notify parent of selection changes, even during hierarchical updates
        // The parent needs to know about hierarchical selections to update its own state
        onSelectionChange(selectedRows);
      }
    }
  }, [selectedRows, onSelectionChange]);

  // Expose methods through ref
  _react["default"].useImperativeHandle(forwardedRef, function () {
    return {
      selectedRows: selectedRows,
      updateRowSelection: updateRowSelection,
      sortFilters: sortFilters,
      applyColumnSortFilter: externalHandlers.applyColumnSortFilter,
      clearAllSortFilters: externalHandlers.clearAllSortFilters,
      clearColumnSortFilter: externalHandlers.clearColumnSortFilter
    };
  }, [selectedRows, updateRowSelection, sortFilters, externalHandlers]);

  // Helper function to create callback for applying filters
  var createFilterCallback = _react["default"].useCallback(function (columnId) {
    return function (config) {
      handleApplyFilters(columnId, config.sort, config.filters);
    };
  }, [handleApplyFilters]);

  // Helper function to calculate filtered data for a column, excluding its own filter
  var calculateFilteredDataForColumn = _react["default"].useCallback(function (column, columnId) {
    if (!rows) return [];

    // Create a temporary filter state without the current column's filter
    var tempFilters = _objectSpread({}, sortFilters);
    delete tempFilters[columnId];

    // Apply all other filters to get the relevant data
    var mutableRows = Array.from(rows);
    var filteredRows = (0, _filterSortUtils.applyFiltersAndSorting)(mutableRows, tempFilters, columns || []);

    // Extract unique values from the filtered rows
    return _toConsumableArray(new Set(filteredRows.map(function (r) {
      var _r$column$field;
      return String((_r$column$field = r[column.field]) !== null && _r$column$field !== void 0 ? _r$column$field : "");
    })));
  }, [rows, sortFilters, columns]);

  // Function to process columns that need interactive features
  var processInteractiveColumn = _react["default"].useCallback(function (column) {
    var columnId = (0, _filterSortUtils.generateColumnId)(column.headerName, column.field);
    var currentFilterState = sortFilters[columnId];

    // Calculate filter data by applying all filters EXCEPT the current column's filter
    // This way, when you open a filter dropdown, you see only the values that would be visible
    // based on other active filters
    var data = calculateFilteredDataForColumn(column, columnId);
    return _objectSpread(_objectSpread({}, column), {}, {
      sortable: false,
      disableColumnMenu: true,
      renderHeader: createInteractiveHeaderRenderer(column, data, currentFilterState, columnId, createFilterCallback)
    });
  }, [sortFilters, calculateFilteredDataForColumn, createFilterCallback]);

  // Function to process columns that need simple headers
  var processSimpleColumn = _react["default"].useCallback(function (column) {
    return _objectSpread(_objectSpread({}, column), {}, {
      sortable: false,
      disableColumnMenu: true,
      renderHeader: createSimpleHeaderRenderer(column)
    });
  }, []);

  // Create custom checkbox column if checkboxSelection is enabled
  var customColumns = _react["default"].useMemo(function () {
    if (!columns) return columns;

    // Process columns to add custom headers for all columns
    var processedColumns = columns.map(function (column, _index) {
      // Skip if column already has a renderHeader
      if (column.renderHeader) return column;

      // Use specific processing functions based on column properties
      var needsInteractiveFeatures = column.sortable === true || column.filterable === true;
      return needsInteractiveFeatures ? processInteractiveColumn(column) : processSimpleColumn(column);
    });
    if (!checkboxSelection) return processedColumns;
    var checkboxColumn = {
      field: "__checkbox__",
      headerName: "",
      width: 50,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderHeader: function renderHeader() {
        var _getHeaderState = getHeaderState(),
          checked = _getHeaderState.checked,
          indeterminate = _getHeaderState.indeterminate;
        return /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
          color: "primary",
          checked: checked,
          indeterminate: indeterminate,
          onChange: function onChange(event) {
            handleSelectAll(event.target.checked);
          }
        });
      },
      renderCell: function renderCell(params) {
        // Determine checkbox state
        var isRowSelected = params.row.selected;
        var _getChildrenState = getChildrenState(params.row.id),
          allSelected = _getChildrenState.allSelected,
          someSelected = _getChildrenState.someSelected;

        // Row is checked if it's selected
        var isChecked = isRowSelected;

        // Row is indeterminate if it has some (but not all) descendants selected
        var isIndeterminate = someSelected && !allSelected;
        return /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
          color: "primary",
          checked: isChecked,
          indeterminate: isIndeterminate,
          onChange: function onChange(event) {
            updateRowSelection(params.row.id, event.target.checked);
          }
        });
      }
    };
    return [checkboxColumn].concat(_toConsumableArray(processedColumns));
  }, [checkboxSelection, columns, processInteractiveColumn, processSimpleColumn, getHeaderState, handleSelectAll, getChildrenState, updateRowSelection]);
  return /*#__PURE__*/_react["default"].createElement(StyledDataGrid, _extends({}, restProps, {
    rows: processedRows,
    columns: customColumns,
    checkboxSelection: false // Disable default checkbox since we're using custom
    ,
    localeText: {
      MuiTablePagination: {
        labelRowsPerPage: "Items per page:"
      }
    }
  }));
};

// Wrapper component with forwardRef
var CustomGrid = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(CustomGridInternal, _extends({}, props, {
    forwardedRef: ref
  }));
});
CustomGrid.displayName = "CustomGrid";
var _default = exports["default"] = CustomGrid;